import React, { FC } from "react";
import { MenuItem, SelectChangeEvent } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { useGetPreviousSubmission } from "@api";
import { useMultistepFormStore } from "@components/common/MultistepForm";
import { Select } from "@components/base";
import { useUserStore } from "@store/user";

const PreviousSubmissionsSelect: FC = () => {
  const {
    formSettings: { formBasics, editMode },
    selectedPreviousSubmissions,
    setSelectedPreviousSubmissions,
  } = useMultistepFormStore();
  const { user } = useUserStore();
  const { previousSubmissions, previousSubmissionsEnabled } =
    useGetPreviousSubmission(
      user,
      {
        formId: formBasics.id,
      },
      !editMode,
    );
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent<unknown>): void => {
    const {
      target: { value },
    } = event;

    setSelectedPreviousSubmissions(
      typeof value === "string" ? value.split(",") : (value as string[]),
    );
  };

  return previousSubmissionsEnabled &&
    previousSubmissions &&
    previousSubmissions.length > 0 ? (
    <Select
      size="small"
      variant="filled"
      color="secondary"
      displayEmpty
      multiple
      renderValue={(value) => {
        const selected = value as string[];

        if (!selected || selected.length === 0) {
          return <em>{t("forms.compareTitle")}</em>;
        }

        return `${selected.length} submissions selected`;
      }}
      value={selectedPreviousSubmissions}
      onChange={handleChange}
    >
      {previousSubmissions?.map((submission) => (
        <MenuItem key={submission.submissionId} value={submission.formId}>
          {submission.formName}
          {" - "}
          {dayjs(submission.createdAt).format("DD.MM.YYYY")}
        </MenuItem>
      ))}
    </Select>
  ) : null;
};

export default PreviousSubmissionsSelect;
